export enum DeviceFormFactor {
    Phone = "phone",
    Tablet = "tablet",
    Desktop = "desktop",
}
